const InstitutionGroups = () => import("./views/InstitutionGroups.vue");
const InstitutionGroupCreate = () => import("./views/InstitutionGroupCreate.vue");
const InstitutionGroupEdit = () => import("./views/InstitutionGroupEdit.vue");

const routes = [
  {
    path: "/institutionGroups",
    name: "institutionGroups.list",
    component: InstitutionGroups,
    meta: { roles: ["ROLE_ADMIN"] },
  },
  {
    path: "/institutionGroups/create",
    name: "institutionGroups.create",
    component: InstitutionGroupCreate,
    meta: { roles: ["ROLE_ADMIN"] },
  },
  {
    path: "/institutionGroups/:id/edit",
    name: "institutionGroups.edit",
    component: InstitutionGroupEdit,
    props: (route: { params: { id: string } }) => ({ id: +route.params.id }),
    meta: { roles: ["ROLE_ADMIN"] },
  },
];

export default routes;
